<template>
  <div v-if="$isMobile()">
    <DataOperatorMobile v-if="isOperator" />
    <DataMobile v-else />
  </div>
  <div v-else>
    <DataUnifiedDesktop :isOperator="isOperator" />
  </div>

</template>

<script>

import DataMobile from "./status-mobile.vue";
import DataOperatorMobile from "./status-mobile-operator.vue";
import DataUnifiedDesktop from "./status-desktop.vue";

export default {
  created() {
    this.getUserView();
  },
  components: {
    DataMobile,
    DataOperatorMobile,
    DataUnifiedDesktop
  },
  data() {
    return {
      isOperator: false
    };
  },
  methods: {
    async getUserView() {
      await this.$store.dispatch("users/loadProfile");
      var user = this.$store.getters["users/getProfile"];
      this.isOperator = user.defaultView?.toLowerCase() == 'operator';
    }
  }
};
</script>

<style scoped>
.ph {
  /* page header */
  height: 50px;
}
</style>
